import { gql } from '@apollo/client';

const EDIT_JOB = gql`
  mutation EditJob($input: EditJobInput!) {
    editJob(input: $input) {
      revisionId
    }
  }
`;

export default EDIT_JOB;
